import { render, staticRenderFns } from "./Bull.vue?vue&type=template&id=2928c822&"
import script from "./Bull.vue?vue&type=script&lang=js&"
export * from "./Bull.vue?vue&type=script&lang=js&"
import style0 from "./Bull.vue?vue&type=style&index=0&id=2928c822&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports